import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'

import MobileMenu from '../../components/MobileMenu'
import Header from '../../components/Header'
import { ToastContainer } from 'react-toastify';
import TableListFacebook from '../../components/TableListFacebook'
import Filter from '../../components/Filter'
import ModalFacebook from '../../components/ModalFacebook'
import { PostsContext } from '../../context/posts'

const CardWrapper = styled.section`
    background-color: #fafafa;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        padding: 1.7rem;

        display: flex;
        flex:1;
        height: 100vh;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`


const Facebook = () => {
    const {getByName} = useContext(PostsContext)

    const [data] = useState([
        {
            name: "Id"
        },
        {
            name:"Post"
        },
        {
            name: "Imagem "
        },
        {
            name: "Excluir"
        }
    ])
    const [modalShow, setModalShow] = useState(false)


    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>

                <div className='colum_primary'>
                    <SidebarEl />
                </div>

                <FixWidthSidebar />

                <div className='colum_secondary'>
                    <Header name={"Posts Facebook"} />
                    <Filter buttonName={"Adicionar"} onChange={(e) => getByName(e.target.value)} onClick={() => setModalShow(true)} type={1} />
                    <TableListFacebook structure={data} />

                </div>

                <MobileMenu />
                <ModalFacebook
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
            </CardWrapper>
        </motion.div>

    )
}

export default Facebook